/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1254
 */

var r = require(/* 634 */"./1253/634")
module.exports = /MSIE|Trident/.test(r)
